import SitePage                   from 'components/Site/Page';
import AuthView                   from 'views/Site/Auth';
import { useTranslation }         from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const AuthPage = (props) => {
  const { t } = useTranslation('common');
  const title = t('site.pages.auth');

  return (
    <SitePage 
      {...props}
      siteViewClass="flex-column"
      siteViewContentClass="flex-center"
      title={title}
    >
      <AuthView title={title}/>
    </SitePage>
  )
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common'])
    }
  }
}

export default AuthPage;